<template>
<pre v-html="code"></pre>  
</template>
<script>
import hljs from 'highlight.js'

export default {
  
    props: {
        attribute: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        code() {
            const origins = this.attribute.value.map((origin) => {
                return `'${origin}'`
            })
            
            return hljs.highlight(`
// config/cors.php    
'allowed_origins' => [
  ${origins}
]
`, {language: 'php'}).value
        }
    }

}
</script>